import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import './style.less';
const myImg =  <img src='https://gw.alipayobjects.com/zos/rmsportal/GIyMDJnuqmcqPLpHCSkj.svg' className="spe am-icon " alt=""  />;

export default class ResultPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
        // let url = global.constants.wx_tijian + this.props.match.url;
        // fun.wxshare(url, '防癌早筛畅享健康双十一', '防癌早筛畅享健康双十一,必检清单', imgURL);
    }
    onLink = (url, e) => {
        // history.push(url);
        // history.go();
    }
    render() {
        return <div style={{height:document.documentElement.clientHeight-46}}>
            <CommonlyHead barname="活动" />
            <div className="resultpage" >            
            <div className="resultdiv">
              {myImg}
              <div className="title">抱歉，本轮活动已结束！</div>
              <div  className="des">敬请期待下一轮活动,</div>
              <div className="des">感谢您的关注</div>
            </div> 
        </div >
        </div>;
    }
}